// las-currency-converter.js — v2
// Géoloc : Shopify localization (pas d'API externe)
// Taux live : frankfurter.app (ECB) pour EUR/GBP/AUD — cache 24h
// GCC + USD : pegged/fixe, hardcodés

(function () {
  'use strict';

  const BASE = 'AED';

  // Devises pegged ou ultra-stables (ne nécessitent pas de fetch live)
  const PEGGED = {
    AED: 1,
    USD: 0.2723,   // AED pegged à USD exactement (3.6725)
    SAR: 1.0211,   // SAR pegged USD à 3.75
    QAR: 0.9916,   // QAR pegged USD à 3.64
    BHD: 0.1023,   // BHD pegged USD à 0.376
    OMR: 0.1047,   // OMR pegged USD à 0.385
    KWD: 0.0835,   // KWD managed float, très stable
  };

  // Devises flottantes — fetchées depuis frankfurter.app
  const FLOAT = ['EUR', 'GBP', 'AUD'];

  const SYMBOLS = {
    AED: 'AED', USD: '$', EUR: '€', GBP: '£', AUD: 'A$',
    SAR: 'SAR', KWD: 'KWD', QAR: 'QAR', OMR: 'OMR', BHD: 'BHD',
  };

  // Décimales : KWD/BHD/OMR = 3 chiffres après virgule
  const DECIMALS = { KWD: 3 };

  const COUNTRY_MAP = {
    AE: 'AED', SA: 'SAR', KW: 'KWD', QA: 'QAR', OM: 'OMR', BH: 'BHD',
    US: 'USD', GB: 'GBP', AU: 'AUD',
    FR: 'EUR', DE: 'EUR', IT: 'EUR', ES: 'EUR', PT: 'EUR', NL: 'EUR',
    BE: 'EUR', LU: 'EUR', IE: 'EUR', AT: 'EUR', FI: 'EUR', GR: 'EUR',
    CY: 'EUR', SK: 'EUR', SI: 'EUR', LV: 'EUR', LT: 'EUR', EE: 'EUR',
    MT: 'EUR', CH: 'EUR', DK: 'EUR', SE: 'EUR', NO: 'EUR',
  };

  const CACHE_KEY   = 'las_rates_v2';
  const CURRENCY_KEY = 'lasCurrency';
  const TTL = 24 * 60 * 60 * 1000; // 24h

  // ─── Rates ───────────────────────────────────────────────────────────────

  function getCachedRates() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const { ts, rates } = JSON.parse(raw);
      if (Date.now() - ts < TTL) return rates;
    } catch (_) {}
    return null;
  }

  function setCachedRates(rates) {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), rates }));
  }

  async function fetchFloatRates() {
    try {
      const res = await fetch(
        'https://api.frankfurter.app/latest?from=AED&to=' + FLOAT.join(',')
      );
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const { rates } = await res.json();
      return rates; // { EUR: 0.248, GBP: 0.214, AUD: 0.412 }
    } catch (e) {
      console.warn('[LASCurrency] Rate fetch failed, using fallback.', e.message);
      return null;
    }
  }

  async function getRates() {
    const cached = getCachedRates();
    if (cached) return { ...PEGGED, ...cached };

    const live = await fetchFloatRates();
    if (live) {
      setCachedRates(live);
      return { ...PEGGED, ...live };
    }

    // Fallback hardcodé si l'API est down
    return { ...PEGGED, EUR: 0.248, GBP: 0.214, AUD: 0.412 };
  }

  // ─── Preference ──────────────────────────────────────────────────────────

  function getSaved()       { return localStorage.getItem(CURRENCY_KEY); }
  function save(c)          { localStorage.setItem(CURRENCY_KEY, c); }

  function detectFromCountry() {
    const code = window.LAS_COUNTRY_CODE || '';
    return COUNTRY_MAP[code] || BASE;
  }

  // ─── Conversion ──────────────────────────────────────────────────────────

  function fmt(amount, currency) {
    const symbol   = SYMBOLS[currency] || currency;
    const decimals = DECIMALS[currency] || 2;
    return symbol + '\u00A0' + amount.toFixed(decimals);
  }

  function convertAll(rates) {
    const currency = getSaved() || BASE;
    const rate     = rates[currency] || 1;

    document.querySelectorAll('[data-price-aed]').forEach(function (el) {
      const aed = parseFloat(el.dataset.priceAed);
      if (isNaN(aed)) return;
      // On remplace le texte du nœud direct, sans toucher aux enfants structurels
      const moneyEl = el.querySelector('.money') || el;
      moneyEl.textContent = fmt(aed * rate, currency);
    });

    // Sélecteur manuel
    document.querySelectorAll('[data-las-currency-selector]').forEach(function (sel) {
      sel.value = currency;
    });
  }

  // ─── Selector ────────────────────────────────────────────────────────────

  function initSelector(rates) {
    document.querySelectorAll('[data-las-currency-selector]').forEach(function (sel) {
      sel.value = getSaved() || BASE;
      sel.addEventListener('change', function () {
        save(this.value);
        convertAll(rates);
      });
    });
  }

  // ─── MutationObserver : cart drawer ──────────────────────────────────────

  function watchCart(rates) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    let debounce;
    const obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { convertAll(rates); }, 50);
    });

    obs.observe(drawer, { childList: true, subtree: true });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  async function init() {
    const rates = await getRates();

    if (!getSaved()) save(detectFromCountry());

    convertAll(rates);
    initSelector(rates);
    watchCart(rates);
  }

  document.addEventListener('DOMContentLoaded', init);

  // API publique (console / autres scripts)
  window.LASCurrency = {
    setCurrency: async function (c) {
      save(c);
      convertAll(await getRates());
    },
    getCurrency: getSaved,
    refreshRates: async function () {
      localStorage.removeItem(CACHE_KEY);
      const rates = await getRates();
      convertAll(rates);
    },
  };
})();
